__turbopack_context__.v({
  "isOn": "switch-module__7I7rHa__isOn",
  "thumb": "switch-module__7I7rHa__thumb",
  "toneSage": "switch-module__7I7rHa__toneSage",
  "track": "switch-module__7I7rHa__track",
});
